import styled from '@emotion/styled';
import { mq } from '@/utils/mediaQuery';

export const CommonTitleOne = styled.div(({ theme, lowercase }) => ({
  fontWeight: theme.fontWeight.extraBold,
  textTransform: lowercase ? 'initial' : 'uppercase',
  fontSize: '3.2rem',

  [mq('tablet')]: {
    fontSize: '3.6rem',
  },

  [mq('desktop')]: {
    fontSize: '4.8rem',
  },
}));

export const CommonTitleTwo = styled.div(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  fontSize: '2.4rem',

  [mq('desktop')]: {
    fontSize: '3.2rem',
  },
}));

export const CommonDescOne = styled.div(({ theme }) => ({
  fontWeight: theme.fontWeight.regular,
  fontSize: '1.6rem',
  lineHeight: '1.5',
  fontFamily: theme.fontFamily.secondaryFont,

  [mq('tablet')]: {
    fontSize: '1.8rem',
  },

  [mq('desktop')]: {
    fontSize: '2rem',
  },
}));

export const CommonDescTwo = styled.div(({ theme }) => ({
  fontWeight: theme.fontWeight.regular,
  fontSize: '1.8rem',
  lineHeight: '1.5',
  fontFamily: theme.fontFamily.secondaryFont,

  [mq('tablet')]: {
    fontSize: '1.8rem',
  },

  [mq('desktop')]: {
    fontSize: '2.4rem',
  },
}));
